module.exports = __webpack_public_path__ + "img/cards1_front128.f3cabc60.png";